import React from "react";
import PropTypes from "prop-types";
import ConnectedDetectCategoryUi from "../Pages/RegistrationPage/ConnectedDetectCategoryUi";
import ConnectedRegistrationRole from "../Pages/RegistrationPage/ConnectedRegistrationRole";
import ConnectedFundraisingGoal from "../Pages/RegistrationPage/ConnectedFundraisingGoal";

const RegistrationContentControl = ({
    showRegistrationRole = true,
    showRemainingForm = true,
    controlId,
}) => (
    // ------------------------------------------------------------------------
    // TODO:
    // See if it is possible to add showDetectCategory logic to hide the
    // <DetectCategoryUi/> component completely when nothing is displayed.
    // This will remove the visual space that this component occupies when
    // completing a single category, when:
    // 1. The user is completing a $0 registration.
    // 2. The registration fee is hidden.
    // 3. Team registrations are disabled.
    // ------------------------------------------------------------------------
    <div>
        <div className="grid">
            {/* Keep spacing above and below RegistrationContent consistent */}
            <div className="col col--12 -padding-top--30">
                <ConnectedDetectCategoryUi controlId={controlId} />
            </div>
        </div>

        {showRegistrationRole && (
            <div className="grid">
                <div className="col col--12 col--no-top-gutter">
                    <ConnectedRegistrationRole controlId={controlId} />
                </div>
            </div>
        )}

        {showRemainingForm && (
            <div className="grid">
                <div className="col col--12">
                    <ConnectedFundraisingGoal controlId={controlId} />
                </div>
            </div>
        )}
    </div>
);

RegistrationContentControl.propTypes = {
    showRegistrationRole: PropTypes.bool,
    showRemainingForm: PropTypes.bool,
    controlId: PropTypes.number.isRequired,
};

export default RegistrationContentControl;
